// Helpers for "coach v2" plan changes (patch / move / add / remove).
// The backend sends a `preview` for coach options; chat proposals only carry `changes`,
// so we rebuild an equivalent preview client side from the current plan when possible.

const PREVIEW_FIELDS = ['id', 'date', 'day', 'type', 'title', 'distance_km', 'duration_min', 'altitude_gain_m'];

const pickPreviewFields = (w) => {
  if (!w || typeof w !== 'object') return null;
  const out = {};
  PREVIEW_FIELDS.forEach((k) => {
    if (w[k] !== undefined) out[k] = w[k];
  });
  return out;
};

export function findPlanWorkout(plan, workoutId) {
  if (!plan || !workoutId) return null;
  const weeks = Array.isArray(plan?.weeks) ? plan.weeks : [];
  for (const week of weeks) {
    const ws = Array.isArray(week?.workouts) ? week.workouts : [];
    const found = ws.find((w) => w && String(w.id) === String(workoutId));
    if (found) return found;
  }
  return null;
}

export function buildPreviewFromChanges(changes, plan = null) {
  return (Array.isArray(changes) ? changes : []).map((change) => {
    const op = String(change?.op || 'patch');
    const source = findPlanWorkout(plan, change?.workout_id);
    const before = source ? pickPreviewFields(source) : null;
    const patch = change?.workout && typeof change.workout === 'object' ? pickPreviewFields(change.workout) : {};
    if (op === 'remove') return { op, before: before || (change?.date ? { date: change.date } : null), after: null };
    if (op === 'add') return { op, before: null, after: { ...patch, date: change?.date || patch?.date || null } };
    if (op === 'move') {
      return {
        op,
        before,
        after: { ...(before || {}), ...(patch || {}), date: change?.date || before?.date || null }
      };
    }
    return {
      op: 'patch',
      before,
      after: { ...(before || {}), ...(patch || {}), date: change?.date || before?.date || patch?.date || null }
    };
  });
}

// Returns the list of events days (ISO) covered by an event.
export function eventDates(event) {
  const start = String(event?.start_date || '');
  const end = String(event?.end_date || start);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start)) return [];
  const out = [];
  const d = new Date(`${start}T00:00:00Z`);
  for (let i = 0; i < 31; i += 1) {
    const iso = d.toISOString().slice(0, 10);
    if (iso > end) break;
    out.push(iso);
    d.setUTCDate(d.getUTCDate() + 1);
  }
  return out;
}

export function formatShortDate(iso, lang) {
  if (!iso) return '';
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return String(iso);
  try {
    return d.toLocaleDateString(lang || undefined, { weekday: 'short', day: 'numeric', month: 'short' });
  } catch (e) {
    return String(iso);
  }
}
